import { GatedButton } from '../Access/GatedButton';
import { OPEN } from '../Access/utils/access-gate.util';

import type { SplashScreenAction } from './types/splash-screen-action.type';

export const SplashScreenButton = ({
  action: { label, onClick, disabled, gate = OPEN },
}: Readonly<{ action: SplashScreenAction }>) => {
  const isAvailable = !disabled && gate.isAllowed;

  return (
    <GatedButton
      autoFocus={isAvailable}
      disabled={disabled}
      gate={gate}
      // The focus is given on mount only: the button, closed while its access is pending, takes it
      // once open.
      key={String(isAvailable)}
      onClick={onClick}
      size="large"
      variant="contained"
    >
      {label}
    </GatedButton>
  );
};
